import { getAPIToken } from '@instamenu/context-firebase';

export async function reframeImage({
  imageSrc,
  aspectRatio,
}: {
  imageSrc: string;
  aspectRatio?: string;
}) {
  const token = await getAPIToken();
  const response = await fetch('/api/ai/image/reframe', {
    method: 'POST',
    headers: token ? { Authorization: `Bearer ${token}` } : {},
    body: JSON.stringify({ imageSrc, aspectRatio }),
  });

  if (!response.ok) throw new Error('Failed to process image');
  return await response.json();
}
